import { Injectable } from '@angular/core'
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http'
import { map, Observable } from 'rxjs'
import { environment } from '../../environments/environment'
import { instanceOfResponseDto, ResponseDto } from '../models/response-dto'

@Injectable()
export class LambdaInterceptor implements HttpInterceptor {
    private okRegExp: RegExp = RegExp('^2[0-9]{2}$')

    constructor() {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<ResponseDto<any>>> {
        if (RegExp(environment.baseUrl).exec(req.url)) {
            return this.handleLambdaResponse(req, next)
        } else {
            return next.handle(req)
        }
    }

    private handleLambdaResponse(httpRequest: HttpRequest<any>, next: HttpHandler) {
        return next.handle(httpRequest).pipe(map((event) => this.mapLambdaResponse(event)))
    }

    private mapLambdaResponse(event: HttpEvent<ResponseDto<any>>) {
        if (event instanceof HttpResponse && instanceOfResponseDto(event.body)) {
            const statusCodeStr = event.body.statusCodeValue?.toString() || event.body.statusCode?.match(/^\d+/)?.[0] || '200'
            const httpStatusIsOk: boolean = !!this.okRegExp.exec(statusCodeStr)
            const statusCodeNum = parseInt(statusCodeStr, 10)

            if (!httpStatusIsOk) {
                throw new HttpErrorResponse({
                    status: statusCodeNum,
                    statusText: event.body.statusCode,
                    error: event.body.body,
                })
            }
            return event.clone({
                body: event.body.body,
                status: statusCodeNum,
                statusText: event.body.statusCode,
            })
        } else {
            return event
        }
    }
}
